<template>
  <Card :btnMsg="$t('formBasic.btn_text')" @changeStep="changeStep">
    <div class="card-formBasic">
      <LanguageS
        class="language-btn-box"
        v-model="form.area_id"
        :areaList="config"
      ></LanguageS>
      <div class="card-content">
        <div class="reference-step-heading">
          <!-- <span>1</span> -->
          <div>
            <p class="card-title" v-html="$t('formBasic.title')"></p>
            <small>{{ $t("details") }}</small>
          </div>
        </div>
        <a-form-model ref="formBasic" :model="form" :rules="formRules">
          <div class="code-box">
            <!-- <a-form-model-item :label="$t('formBasic.platform_name')" prop="platform_id">
              <a-select :placeholder="$t('formBasic.platform_name_placeholder')" v-model="form.platform_id" size="large" type="primary">
                <a-select-option
                  v-for="item in config.platform_list"
                  :key="item.platform_id"
                  :value="item.platform_id"
                >
                  {{ item.platform_name }}
                </a-select-option>
              </a-select>
            </a-form-model-item> -->
            <a-form-model-item
              :label="$t('formBasic.form_name')"
              prop="nick_name"
            >
              <a-input
                :placeholder="$t('formBasic.form_name_placeholder')"
                v-model="form.nick_name"
                size="large"
                type="primary"
              ></a-input>
            </a-form-model-item>
            <a-form-model-item :colon="false" prop="email">
              <template slot="label">
                {{ $t("formBasic.form_email") }}:
                <small
                  style="font-size: 11px; font-weight: 400; color: #94a3b8"
                >
                  ({{ $t("formBasic.form_email_note") }})
                </small>
              </template>
              <div style="display: flex; align-items: flex-start">
                <a-input
                  class="email-input"
                  :placeholder="$t('formBasic.form_email_placeholder')"
                  v-model="form.email"
                  size="large"
                  type="primary"
                >
                  <!-- <template #suffix>
                    <van-button type="warning" size="small" :disabled="isCountDown" @click="sendEmailCode">
                      {{ isCountDown ? `${countDownTime}s` : $t('formBasic.get_code') }}
                    </van-button>
                  </template> -->
                </a-input>
              </div>
            </a-form-model-item>
            <!-- <a-form-model-item :label="$t('formBasic.form_code')" prop="code">
              <a-input
                :placeholder="$t('formBasic.form_code_placeholder')"
                v-model="form.code"
                size="large"
                type="primary"
                :maxLength="6"
              ></a-input>
            </a-form-model-item> -->
            <a-form-model-item label="" prop="order_id">
              <div class="order-q-box">
                <label
                  :title="$t('formBasic.form_order')"
                  class="ant-form-item-required point"
                  >{{ $t("formBasic.form_order") }}:</label
                >
                <div @click="showOrderHelp" class="order-q point">?</div>
                <van-dialog
                  v-model="showHelp"
                  theme="round-button"
                  :title="$t('formBasic.order_help_title')"
                  confirm-button-color="#ffd814"
                  :confirm-button-text="$t('formBasic.confirm_btn')"
                >
                  <div
                    style="
                      padding: 24px;
                      text-align: center;
                      line-height: 1.6;
                      font-size: 13px;
                    "
                  >
                    {{ $t("formBasic.order_help_content") }}
                    <br />
                    <a
                      href="mailto:customerservice8@yeah.net"
                      style="color: #f40000; font-weight: bold"
                    >
                      customerservice8@yeah.net
                    </a>
                  </div>
                </van-dialog>
              </div>
              <a-input
                v-model="form.order_id"
                size="large"
                type="primary"
                :placeholder="$t('formBasic.form_order_placeholder')"
              />
            </a-form-model-item>
          </div>
        </a-form-model>
        <div class="order-why-box">
          <span class="order-why point" @click="showOrderHelp">{{
            $t("formBasic.order_why")
          }}</span>
          <span class="order-answer">{{ $t("formBasic.order_answer") }}</span>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from "@/components/card.vue";
import LanguageS from "@/components/language.vue";
import {
  getConfig,
  postEmailCode,
  postValidateCode,
  postValidateOrderCode,
} from "@/api/portal";
export default {
  components: {
    Card,
    LanguageS,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showHelp: false, // 控制弹窗显示
      form: {},
      formRules: {
        // platform_id: [{ required: true, message: this.$t('formBasic.form_platform_placeholder'), trigger: 'blur' }],
        nick_name: [
          {
            required: true,
            message: this.$t("formBasic.form_name_placeholder"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("formBasic.form_email_placeholder"),
            trigger: "blur",
          },
          {
            // 使用方案一的正则表达式
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: this.$t("formBasic.form_email_error_placeholder"),
            trigger: "change",
          },
        ],
        // code: [
        //   {
        //     required: true,
        //     message: this.$t("formBasic.form_code_placeholder"),
        //     trigger: "blur",
        //   },
        // ],
        order_id: [
          {
            required: true,
            message: this.$t("formBasic.form_order_placeholder"),
            trigger: "blur",
          },
          // {
          //   pattern: /^\d{3}-\d{7}-\d{7}$/,
          //   message: this.$t('formBasic.form_order_error_placeholder'),
          //   trigger: 'change',
          // },
          // {
          //   pattern: /^\d{3}-\d{7}-\d{7}$/,
          //   message: this.$t('formBasic.form_order_error_placeholder'),
          //   trigger: 'blur',
          // },
        ],
      },
      config: [],
      isCountDown: false,
      countDownTime: 60,
      timer: null,
    };
  },
  mounted() {
    // Temporary local debugging defaults; remove after debugging is complete.
    this.form = {
      ...this.value,
      nick_name: this.value.nick_name || "",
      email: this.value.email || "",
      order_id: this.value.order_id || "",
    };
    this.getConfig();
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.formRules = {
          // platform_id: [{ required: true, message: this.$t('formBasic.form_platform_placeholder'), trigger: 'blur' }],
          nick_name: [
            {
              required: true,
              message: this.$t("formBasic.form_name_placeholder"),
              trigger: "blur",
            },
          ],
          email: [
            {
              required: true,
              message: this.$t("formBasic.form_email_placeholder"),
              trigger: "blur",
            },
            {
              pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: this.$t("formBasic.form_email_error_placeholder"),
              trigger: "change",
            },
          ],
          // code: [
          //   {
          //     required: true,
          //     message: this.$t("formBasic.form_code_placeholder"),
          //     trigger: "blur",
          //   },
          // ],
          order_id: [
            {
              required: true,
              message: this.$t("formBasic.form_order_placeholder"),
              trigger: "blur",
            },
            // {
            //   pattern: /^\d{3}-\d{7}-\d{7}$/,
            //   message: this.$t('formBasic.form_order_error_placeholder'),
            //   trigger: 'change',
            // },
            // {
            //   pattern: /^\d{3}-\d{7}-\d{7}$/,
            //   message: this.$t('formBasic.form_order_error_placeholder'),
            //   trigger: 'blur',
            // },
          ],
        };
        // this.$nextTick(_ => {
        //   this.checkForm();
        // });
      },
    },
  },
  methods: {
    // 发送验证码逻辑
    async sendEmailCode() {
      // 1. 先校验邮箱格式是否正确
      let emailValid = false;
      this.$refs.formBasic.validateField("email", (errorMessage) => {
        if (!errorMessage) emailValid = true;
      });

      if (!emailValid) return;

      // 2. 调用接口 (假设接口名为 getEmailVerifyCode)
      try {
        await postEmailCode({
          email: this.form.email,
          area_id: this.form.area_id,
        });
        this.$toast.success(this.$t("formBasic.code_sent_success"));

        // 3. 开启倒计时
        this.startCountDown();
      } catch (error) {
        console.error("Failed to send code", error);
      }
    },

    startCountDown() {
      this.isCountDown = true;
      this.countDownTime = 60;
      this.timer = setInterval(() => {
        this.countDownTime--;
        if (this.countDownTime <= 0) {
          clearInterval(this.timer);
          this.isCountDown = false;
        }
      }, 1000);
    },

    // 别忘了在组件销毁前清除定时器
    beforeDestroy() {
      if (this.timer) clearInterval(this.timer);
    },
    checkForm() {
      let bol = false;
      this.$refs.formBasic.validate((valid) => {
        if (valid) {
          bol = true;
          return true;
        } else {
          bol = false;
          return false;
        }
      });
      this.$nextTick((_) => {});
      return bol;
    },
    changeStep() {
      let bol = this.checkForm();
      if (bol) {
        this.$parent.loading = true;
        try {
          postValidateOrderCode({
            nick_name: this.form.nick_name,
            email: this.form.email,
            order_id: this.form.order_id,
            // code: this.form.code,
          })
            .then((res) => {
              this.$emit("input", this.form);
              this.$parent.changeStep("showGiftCard", this.form);
            })
            .catch((err) => {
              this.$toast.fail(
                err.data.msg || this.$t("formBasic.orderErrorText"),
              );
            })
            .finally(() => {
              this.$parent.loading = false;
            });
        } catch (e) {
          this.$parent.loading = false;
        }
      }
    },
    formatOrderNumber(e) {
      // 获取输入框的值和当前光标位置
      let input = e.target.value;
      let position = e.target.selectionStart; // 当前光标位置
      // 去除非数字和多余的连字符
      input = input.replace(/[^0-9]/g, "");

      // 插入连字符
      if (input.length > 3) {
        input = input.slice(0, 3) + "-" + input.slice(3);
        if (position === 4) position++; // 调整光标位置
      }
      if (input.length > 11) {
        input = input.slice(0, 11) + "-" + input.slice(11);
        if (position === 12) position++; // 调整光标位置
      }

      // 限制最大长度
      input = input.slice(0, 19);

      // 更新绑定数据
      this.form.order_id = input;

      // 更新输入框的值
      e.target.value = input;

      // 恢复光标位置
      e.target.setSelectionRange(position, position);
    },
    showOrderHelp() {
      this.showHelp = true;
    },
    jumpOrderDetails() {
      // this.$router.push('order-flow');
      window.open(`${location.origin}/order-flow`, "_blank");
    },
    getConfig() {
      getConfig().then((res) => {
        this.config = res.data;
      });
    },
  },
};
</script>

<style lang="scss">
.point {
  cursor: pointer;
}
.van-overlay {
  z-index: 10;
}
.card-formBasic {
  position: relative;
  width: 100%;

  .card-title {
    font-size: 23px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 20px;
  }

  .reference-step-heading small {
    margin-bottom: 10px;
  }

  .van-button {
    height: 40px;
    border: 1px solid#d9d9d9;
  }

  .email-input {
    .ant-input {
      // 留出按钮的宽度，防止文字输入到按钮下面
      padding-right: 90px !important;
    }

    .ant-input-suffix {
      right: 4px; // 让按钮离右边框有一点点距离，更好看
    }

    .van-button {
      height: 32px; // 稍微调小一点，嵌套在内部更精致
      border: none; // 去掉按钮边框，看起来更像一体
    }
  }

  .order-q-box {
    display: flex;
    align-items: center;
    gap: 10px;

    .order-q {
      display: none;
      line-height: 24px;
      text-align: center;
      font-size: 17px;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      background-color: #ffd814;
      font-weight: 500;
    }
  }

  .card-text {
    font-size: 16px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }

  .order-why-box {
    margin-top: 40px;
    display: flex;
    flex-direction: column;

    .order-why {
      font-size: 15px;
      font-weight: 400;
      color: #f40000;
    }

    .order-answer {
      font-size: 15px;
      font-weight: 500;
      color: #1a1a1a;
    }
  }

  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300;
    /* 高亮颜色 */
  }

  .code-box {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 30px;

    .ant-form-item {
      margin-bottom: 0px;
    }
  }
}
</style>
